import { PublicNode } from '../../../__generated__/api'

import { SearchTreeItem } from './types'

export const convertSearchNode = (
  node: PublicNode,
  secondaryGroupLabel?: string,
  group?: string
): SearchTreeItem<PublicNode> => ({
  id: node.id,
  name: node.name,
  item: node,
  children: node.children ? convertSearchNodes(node.children, secondaryGroupLabel) : undefined,
  parentName: node.parentName,
  description: node.description,
  descriptionTitle: node.descriptionTitle,
  caption: node.caption,
  group: node.priority === 2 ? secondaryGroupLabel : group,
})

export const convertSearchNodes = (
  nodes: PublicNode[],
  secondaryGroupLabel?: string,
  group?: string
): Array<SearchTreeItem<PublicNode>> =>
  nodes.map((node) => convertSearchNode(node, secondaryGroupLabel, group))

export const searchTreeItemIconProvider = (item: SearchTreeItem<PublicNode>) =>
  item.item?.icon ? item.item.icon : `${process.env.REACT_APP_NODE_ICON_URL}mehilainen.svg`

export const autocompleteItemIconProvider = (src?: string) =>
  src
    ? `${process.env.REACT_APP_NODE_ICON_URL}${src}.svg`
    : `${process.env.REACT_APP_NODE_ICON_URL}mehilainen.svg`

type ObjectWithGroup = {
  group?: string
}

export const groupItems = <T extends object & ObjectWithGroup>(items: T[], noGroupId: string) =>
  items.reduce<Record<string, T[]>>((acc, cur) => {
    const index = cur.group ?? noGroupId
    if (!acc[index]) {
      acc[index] = []
    }
    acc[index].push(cur)
    return acc
  }, {})
